import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { QuestionAnswerRounded } from "@mui/icons-material";

import { H2 } from "commons";

import { LiveSupport } from "../../helpers/ContactHelpers";

export function ContactBlock({ addressLines, title, email, contact, phone, livechat, support }) {
    const getAddressLines = () =>
        addressLines
            .filter(line => !!line)
            .map((line, idx) => (
                <span key={idx}>
                    {line}
                    <br />
                </span>
            ));

    const openLiveSupport = () => new LiveSupport().open();

    return (
        <Container data-testid="contact-block">
            <H2 secondary textAlign="center">
                {title}
            </H2>
            <p>{contact}</p>
            {email && (
                <p>
                    Email: <a href={`mailto:${email}`}>{email}</a>
                </p>
            )}
            {phone && (
                <p>
                    Call: <a href={`tel:${phone}`}>{phone}</a>
                </p>
            )}
            {livechat && (
                <p>
                    <ChatLink id="livechat" onClick={openLiveSupport}>
                        {livechat}
                        <ChatImage />
                    </ChatLink>
                </p>
            )}
            <p>{getAddressLines()}</p>
            {support && <p data-testid="support-info">{support}</p>}
        </Container>
    );
}

const Container = styled.li`
    word-break: break-word;
    text-align: center;
    padding: 10px;
    flex: 1;
`;

export const ChatLink = styled.button`
    font-size: inherit;
    color: ${props => props.theme.primary};
    align-items: center;
    cursor: pointer;
    background: transparent;
    border: none;
    outline: none;
`;

export const ChatImage = styled(QuestionAnswerRounded)`
    float: right;
    padding-left: 6px;
`;

ContactBlock.propTypes = {
    title: PropTypes.string,
    contact: PropTypes.string,
    email: PropTypes.string,
    livechat: PropTypes.string,
    phone: PropTypes.string,
    addressLines: PropTypes.array,
    support: PropTypes.string
};
